import { XMarkIcon } from '@heroicons/react/24/outline';
import { SearchMdIcon } from '@langchain/untitled-ui-icons';

import { IconButton, Input } from '@/design-system';

type DataGridSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  size?: 'sm' | 'md';
};

export function DataGridSearchInput({
  value,
  onChange,
  size = 'sm',
}: DataGridSearchInputProps) {
  return (
    <Input
      placeholder="Search by name..."
      value={value}
      onChange={(value) => onChange(value)}
      leftDecorator={<SearchMdIcon className="size-4" />}
      rightDecorator={
        value ? (
          <IconButton
            icon={XMarkIcon}
            label="Clear"
            onClick={() => onChange('')}
            color="secondary"
            variant="plain"
            size="sm"
          />
        ) : (
          <div className="h-[26px] w-[26px]" />
        )
      }
      className="w-[260px]"
      size={size}
    />
  );
}
